import React from 'react';
import { Link } from 'react-router-dom';
import { Card, Grid, Icon, Typography} from '@material-ui/core';


const QuoteProSettings = () => {
  return (
    <div className="p-8">
      <Grid spacing={3} container className="text-center">
        <Grid item xs={12} sm={3} md={2} >
          <Link to="/configurations/agreements">
            <Card  className="py-8 light-blue-on-hover h-full flex-column justify-center items-center" elevation={8}>
              <Icon className="text-40" color="primary">assignment_turned_in</Icon>
              <Typography variant="h5" className="mt-4 min-h-50 max-w-100" color="primary">Terms and Conditions</Typography>
            </Card>
          </Link>
        </Grid>
      </Grid>
    </div>
  );
};

export default QuoteProSettings;
